// extracted by mini-css-extract-plugin
export var active = "_5x-1";
export var activeSubdued = "_5x-2";
export var compact = "_5x-3";
export var fill = "_5x-6";
export var pulse = "_5x-4";
export var settingHighlightPulse = "_5x-5";
export var wrapper = "_5x-0";